import { render, staticRenderFns } from "./BroadcastPage.vue?vue&type=template&id=523714f9&scoped=true"
import script from "./BroadcastPage.vue?vue&type=script&lang=js"
export * from "./BroadcastPage.vue?vue&type=script&lang=js"
import style0 from "./BroadcastPage.vue?vue&type=style&index=0&id=523714f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523714f9",
  null
  
)

export default component.exports